var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFxDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157158",
    "data-name": "Rectangle 157158",
    width: 16,
    height: 16,
    transform: "translate(229.521 228.815)",
    fill: "#678bff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38251",
    "data-name": "Mask Group 38251",
    transform: "translate(-229.521 -228.815)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(229.479 228.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157157",
    "data-name": "Rectangle 157157",
    width: 16,
    height: 16,
    transform: "translate(0.042 0.042)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Q3_icons",
    "data-name": "Q3 icons",
    transform: "translate(0.856 1.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75098",
    "data-name": "Group 75098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73730",
    "data-name": "Path 73730",
    d: "M10.473,10.2a4.8,4.8,0,0,1,1.143-3.136.653.653,0,0,0-.98-.849A5.945,5.945,0,0,0,9.166,10.2a6.01,6.01,0,0,0,1.47,4.083.719.719,0,0,0,.49.2.784.784,0,0,0,.457-.163.719.719,0,0,0,.033-.947A4.638,4.638,0,0,1,10.473,10.2Z",
    transform: "translate(-3.286 -3.043)",
    fill: "#678bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73731",
    "data-name": "Path 73731",
    d: "M18.56,6.211a.653.653,0,0,0-.98.849A4.8,4.8,0,0,1,18.724,10.2a4.638,4.638,0,0,1-1.143,3.168.719.719,0,0,0,.033.947.784.784,0,0,0,.457.163.719.719,0,0,0,.49-.2A6.01,6.01,0,0,0,20.03,10.2a5.945,5.945,0,0,0-1.47-3.985Z",
    transform: "translate(-5.658 -3.043)",
    fill: "#678bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73732",
    "data-name": "Path 73732",
    d: "M16.193,12.46l-1.078-1.6,1.078-1.6a.661.661,0,0,0-1.111-.719l-.751,1.143L13.58,8.541a.661.661,0,1,0-1.111.719l1.078,1.6-1.078,1.6a.686.686,0,0,0,.2.915.653.653,0,0,0,.359.1.686.686,0,0,0,.555-.294l.751-1.143.751,1.143a.686.686,0,0,0,.555.294.653.653,0,0,0,.359-.1.686.686,0,0,0,.2-.915Z",
    transform: "translate(-4.205 -3.674)",
    fill: "#678bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73733",
    "data-name": "Path 73733",
    d: "M6.143,5.426H5.424l.163-1.143A1.274,1.274,0,0,1,6.862,3.14H7.45a.653.653,0,0,0,0-1.307H6.862A2.646,2.646,0,0,0,4.281,4.087l-.2,1.339H3.2a.653.653,0,0,0,0,1.307h.719l-.817,5.716a1.274,1.274,0,0,1-1.274,1.143H1.57a.653.653,0,0,0,0,1.307h.261a2.646,2.646,0,0,0,2.581-2.254l.817-5.912h.915a.653.653,0,1,0,0-1.307Z",
    transform: "translate(-0.917 -1.833)",
    fill: "#678bff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFxDark);
export default __webpack_public_path__ + "static/media/FX_Dark.80658c01ea673f9b382dc9cc118168b6.svg";
export { ForwardRef as ReactComponent };